import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {ImagePlaceholder} from '@vio/atlas/helpers/ImagePlaceholder'
import {cssTheme} from '@vio/atlas/themes'
import {ImageProvider} from '@vio/core/src/staticContent/types/ImageProvider'

import {ProgressiveImageCarousel} from './ProgressiveImageCarousel'

const CardGalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
  width: 100%;
  border-radius: ${cssTheme.layout.radius.lg};
  overflow: hidden;
  mask-image: radial-gradient(white, black);
  &.--with-placeholder {
    position: relative;
    background-color: ${cssTheme.colors.imagePlaceholder.background};
    color: ${cssTheme.colors.imagePlaceholder.color};
  }
`

interface CardGalleryProps {
  /** Imaging service for resizing */
  imageProvider: ImageProvider

  /** List of images to be displayed */
  images: string[]

  /** Whether the card is the priority card (card in the first position of the list) */
  isPriorityCard?: boolean
}

/**
 * CardGallery is a selection of thumbnails and larger images for display on the hotel card
 *
 * This component requires a parent with a set height to work correctly as the main image is responsive
 * and is designed to grow with the height of the parent container.
 */
export const CardGallery: React.FC<CardGalleryProps> = ({
  images,
  imageProvider,
  isPriorityCard = false
}) => {
  const hasImage = images.length > 0

  return (
    <CardGalleryContainer
      className={cx(!hasImage && '--with-placeholder')}
      data-id="HeroImage"
    >
      {hasImage ? (
        <ProgressiveImageCarousel
          images={images}
          imageProvider={imageProvider}
          isPriorityCard={isPriorityCard}
        />
      ) : (
        <ImagePlaceholder type="hotel" />
      )}
    </CardGalleryContainer>
  )
}
